import { Component } from '@angular/core';

@Component({
  selector: 'app-tax-clearance',
  templateUrl: './tax-clearance.component.html',
  styleUrls: ['./tax-clearance.component.css']
})
export class TaxClearanceComponent {

}
